import Image from 'next/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

import { navLinks } from '../../../constants/links'
import { useActivateChart } from '../../../state/chart/hooks'
import NavLink from '../NavLink'
import MobileMenu from './mobileNavbar'
import UpperNav from './upperNav'
/**
 * @return {JSX.Element} Navbar
 */
export default function Navbar() {
  const { t } = useTranslation()
  const navlinks = navLinks(t)
  const router = useRouter()
  const [, , , { toLiquidity }] = useActivateChart()
  return (
    <>
      <div className="z-10 w-screen">
        <UpperNav />
        <div className="absolute bg-animatednavline ease-in-out duration-500 animate-slidein w-full -translate-x-full h-[0.05em]" />
        <MobileMenu navlinks={navlinks} />
      </div>
      <header className="lg:p-0 pl-8 pr-8 hidden lg:grid landscape:grid lg:landscape:grid grid-flow-col z-[3] items-center lg:pl-4 lg:pr-8 gap-2.5">
        <NavLink href="/home">
          <Image
            className="relative hidden cursor-pointer filterember xl:block justify-self-start"
            alt="EMBER"
            width={65}
            height={65}
            src="/images/main/icon/icon-144x144.png"
          />
        </NavLink>
        <div className="grid justify-between grid-flow-col ml-5 xl:ml-0 lg:ml-10">
          {navlinks.map(({ title, href }) => (
            <NavLink
              onClick={() => {router.pathname === '/swap' && href === '/liquidity' && toLiquidity(true)}}
              key={title}
              id={title + `navlink`}
              className="p-1 font-sans duration-500 ease-out cursor-pointer md:p-2 text-xxs md:text-xs lg:text-sm xl:text-base text-primary whitespace-nowrap"
              href={href}
            >
              {title}
            </NavLink>
          ))}
        </div>
        <div className="relative grid self-center duration-500 ease-out lg:landscape:relative landscape:top-28 landscape:absolute landscape:right-6 lg:landscape:top-0 lg:landscape:right-0 align-center justify-self-end text-secondary"></div>
      </header>
    </>
  )
}
